module.exports = __webpack_public_path__ + "static/media/portfolio7.2e190793.png";